"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalContact = void 0;
var joi_1 = __importDefault(require("joi"));
var office_address_1 = require("./office-address");
exports.internalContact = joi_1.default.object({
    departmentName: joi_1.default.string()
        .min(0)
        .max(100)
        .optional(),
    employeeID: joi_1.default.string()
        .min(8)
        .max(8)
        .optional(),
    officeAddressDescription: office_address_1.officeAddress.optional(),
    positionTitleID: joi_1.default.string()
        .uuid({ version: 'uuidv4' })
        .optional(),
    sectorName: joi_1.default.string()
        .min(0)
        .max(100)
        .optional(),
    titleTypeCode: joi_1.default.alternatives()
        .try(joi_1.default.number()
        .integer()
        .min(0)
        .max(9999), joi_1.default.string().uuid({ version: 'uuidv4' }))
        .optional(),
    titleName: joi_1.default.string()
        .min(0)
        .max(100)
        .optional(),
});
